import {
  ChevronUp,
  Trash2,
  Info,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader, setServiceValue } from "../../../core/redux/action";
import { Link, useParams } from "react-router-dom"; // useLocation
import Select from "react-select";
import apiHandler from "../../common/api";
import config, { NoImage } from "../../../config";

// import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";

import { ServiceInitialData } from "../../../core/json/service_initial_Data";
import ServiceMenuModal from "../../../core/modals/applications/ServicemenuModal";
// import { Modal } from 'bootstrap';

const AddService = ({ isDisable = false, isFromOnboarding = 0 }) => { //setUploadImage
  const params = useParams();
  console.log(params, "787878787854");
  // const location = useLocation();
  // const parts = location.pathname;
  // let pathname = parts?.trim()?.split("/");

  const dispatch = useDispatch();
  const formValue = useSelector((state) => state.ServiceValue);
  const userData = useSelector((state) => state.user_data);
  console.log(formValue, "formvalueData check");
  const [Categorylist, setCategorylist] = useState([]);
  const [serviceOption, setserviceOption] = useState([]);
  const [priceType, setpriceType] = useState([]);
  const [dropdownOptions, setdropdownOptions] = useState([]);
  const [isOpen, setIsopen] = useState(false);
  const [searchService, setSearchService] = useState("");
  const [serviceList, setServiceList] = useState([]);
  const [isProvideHomeService, setIsProvideHomeService] = useState(0)
  const [productlist, setProductlist] = useState([]);


  useEffect(() => {
    return () => {
      if (isFromOnboarding === 1) {
        dispatch(setServiceValue(ServiceInitialData)); // Import ServiceInitialData
      }
    };
  }, [dispatch, isFromOnboarding]);

  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${user_data?.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }
      setProductlist(serviceData?.ResponseData);
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    fetchServiceData();
  }, []);

  console.log(userData, "userData213132321321212")


  console.log(isProvideHomeService, "check final value of isProvideHomeService")

  // const [isOpen, setIsOPen] = useState(false);
  // console.log(isOpen)

  const data = useSelector((state) => state.toggle_header);
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setServiceValue({ ...formValue, [name]: value }));
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;
    dispatch(
      setServiceValue({
        ...formValue,
        [name]: checked ? 1 : 0,
        Pricingandduration: [
          {
            Duration: 0,
            Pricetype: 0,
            Price: 0,
            PricinganddurationID: 0,
          },
        ],
      })
    );
  };

  const handleDelete = (index) => {
    let updatedata = [...formValue.Pricingandduration];

    // Filter out the item at the given index
    updatedata = updatedata.filter((_, indexs) => indexs !== index);

    console.log(updatedata, "4154877");

    dispatch(setServiceValue({ ...formValue, Pricingandduration: updatedata }));
  };

  const handlePriceChange = (index, value) => {
    let updatedata = [...formValue.Pricingandduration];
    updatedata[index] = {
      ...updatedata[index],
      ["Price"]: value,
    };

    dispatch(
      setServiceValue({ ...formValue, ["Pricingandduration"]: updatedata })
    );
    console.log(index, value);
  };

  const handleselectchange = (index, value, label) => {
    let updatedata = [...formValue.Pricingandduration];
    updatedata[index] = {
      ...updatedata[index],
      [label]: value,
    };

    dispatch(
      setServiceValue({ ...formValue, ["Pricingandduration"]: updatedata })
    );
  };
  // Handle select changes
  const handleSelectChange = (e, label) => {
    dispatch(
      setServiceValue({
        ...formValue,
        [label]: e.value,
      })
    );
  };

  // const handleaddvarent = () => {
  //   dispatch(
  //     setServiceValue({
  //       ...formValue,
  //       Pricingandduration: [
  //         ...(formValue.Pricingandduration || []),
  //         {
  //           Duration: 0,
  //           Pricetype: 0,
  //           Price: 0,
  //           PricinganddurationID: 0,
  //         },
  //       ],
  //     })
  //   );
  // };

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryAll?businessId=${userData?.businessId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      const category = response.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.categoryName,
      }));
      setCategorylist(category);
    } else {
      console.log(response, "data");
    }

    const responses = await apiHandler({
      method: "GET",
      route: "Superadmin/serviceAll",
    });
    if (responses.ResponseCode === "SUCCESS") {
      console.log(responses, "data");
      const category = responses.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setserviceOption(category);
    } else {
      console.log(responses, "data");
    }

    const priceTypes = await apiHandler({
      method: "GET",
      route: "Superadmin/priceTypeAll",
    });
    if (priceTypes.ResponseCode === "SUCCESS") {
      console.log(priceTypes, "data");
      const category = priceTypes.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setpriceType(category);
    } else {
      console.log(priceTypes, "data");
    }

    const Duration = await apiHandler({
      method: "GET",
      route: "Business/ServiceDurationAll",
    });
    if (Duration.ResponseCode === "SUCCESS") {
      console.log(Duration, "data");
      const category = Duration.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setdropdownOptions(category);
    } else {
      console.log(Duration, "data");
    }
  };

  const getServiceListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/TeamserviceData?BusinessID=${userData?.businessId}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setServiceList(response.ResponseData);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
    getServiceListApi();
  }, []);

  const user_data = useSelector((state) => state.user_data);
  const [parentchecked, setparentchecked] = useState(true);
  console.log(user_data?.businessUniqueName, "user_data", formValue);

  const handleCheckboxChange = (index, value, label) => {
    let updatedata = [...formValue.Team];
    updatedata[index] = {
      ...updatedata[index],
      [label]: value,
    };

    if (
      formValue?.Team.filter((el) => el.Ischecked == true)?.length !==
      formValue?.Count
    ) {
      setparentchecked(false);
    }

    dispatch(setServiceValue({ ...formValue, ["Team"]: updatedata }));
    console.log(
      formValue?.Team.filter((el) => el.Ischecked == true)?.length,
      "length"
    );
  };

  const handleParentCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    const updatedData = formValue.Team.map((team) => ({
      ...team,
      Ischecked: isChecked,
    }));

    setparentchecked(isChecked);
    dispatch(setServiceValue({ ...formValue, Team: updatedData }));
  };

  // const Handlefile = (e, field) => {
  //   let file = e.target.files[0];
  //   const fileURL = URL.createObjectURL(file);
  //   const formData = {
  //     ...formValue,
  //     [field]: imgpathgenerator(file.name, pathname[1]),
  //     [`serviceLogoPreview`]: fileURL,
  //     ["uniquefileName"]:
  //       JSON.stringify([imgpathgenerator(file.name, pathname[1])]) || "[]",
  //     dirname: `${pathname[1]}`,
  //   };
  //   setUploadImage(file);
  //   dispatch(setServiceValue(formData));
  // };

  // const handleCancel = () => {
  //   dispatch(
  //     setServiceValue({
  //       ...formValue,
  //       serviceLogo: "",
  //       serviceLogoPreview: "",
  //     })
  //   );
  //   setUploadImage(null);
  // };
  // const modalRef = useRef(null);



  const filterServiceData = searchService
    ? serviceList?.filter((el) => {
      return (
        el.name?.toLowerCase().includes(searchService.toLowerCase()) &&
        el.serviceId !== formValue?.ID
      );
    })
    : [];

  console.log(filterServiceData, "filterServiceData");

  const handelSelectServiceForCombo = async (service) => {
    const existingIds = formValue.comboServiceIds
      ? formValue.comboServiceIds.split(",")
      : [];
    if (!existingIds.includes(service?.serviceId.toString())) {
      const updatedIds = [...existingIds, service?.serviceId].join(",");

      const updatedPricingAndDuration = {
        ...formValue.Pricingandduration[0],
        Price:
          Number(formValue.Pricingandduration[0]?.Price || 0) +
          Number(service.price || 0),
        // Duration: (formValue.Pricingandduration[0]?.Duration || 0) + (service.duration || 0),
      };

      dispatch(
        setServiceValue({
          ...formValue,
          Pricingandduration: [updatedPricingAndDuration],
          comboServiceIds: updatedIds,
        })
      );
    }
    setSearchService("");
  };

  const handelRemoveServicesForCombo = async (id) => {
    const existingIds = formValue.comboServiceIds
      ? formValue.comboServiceIds.split(",")
      : [];
    const updatedIds = existingIds
      .filter((serviceId) => serviceId !== id.toString())
      .join(",");

    const removedService = serviceList.find(
      (service) => service.serviceId.toString() === id.toString()
    );
    const updatedPricingAndDuration = {
      ...formValue.Pricingandduration[0],
      Price:
        Number(formValue.Pricingandduration[0]?.Price || 0) -
        Number(removedService?.price || 0),
    };

    dispatch(
      setServiceValue({
        ...formValue,
        comboServiceIds: updatedIds,
        Pricingandduration: [updatedPricingAndDuration],
      })
    );
  };

  useEffect(() => {
    const getBusinessDetailById = async (bId) => {
      const response = await apiHandler({
        method: "GET",
        route: `Business/getbusinessdetailbyid?businessId=${bId || 0}`,
      });
      if (response.ResponseCode === "SUCCESS") {
        const businessData = response.ResponseData[0][0];
        setIsProvideHomeService(businessData?.isProvideHomeService)

      } else {
        console.log(response, "data");
      }
    };

    getBusinessDetailById(userData?.businessId)
  }, [])

  return (
    <div className={isFromOnboarding == 1 ? "" : "page-wrapper"}>
      {/* Bootstrap Modal */}
      {isOpen && (
        <ServiceMenuModal
          isOpen={isOpen}
          setIsOpen={setIsopen}
          businessId={userData?.businessId}
          callBack={() => {
            prodcutDataListApi();
          }}
        />
      )}

      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Service Details</h4>
              <h6>Introduce Your New Offering</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <form>
          {/* /product list */}
          {/* <div className="text-end mb-3">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>
              <button onClick={HandleSubmit} className="btn btn-submit">
                Save
              </button>
            </div> */}
        </form>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpen-collapseOne"
                >
                  <div className="card-title-head">
                    <h6 className="m-0 p-0" style={{ border: "none" }}>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Basic Details
                    </h6>
                  </div>
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpen-headingOne"
              >
                {/* <div className="mb-3">
                        <label className="form-label">Service Logo</label>

                        <img
                          src={
                            formValue?.serviceLogoPreview
                              ? formValue?.serviceLogoPreview
                              : formValue?.serviceLogo
                              ? config.Imageurl + formValue?.serviceLogo
                              : NoImage
                          }
                          alt="Service image"
                          height="100px"
                          width="100px"
                        />

                        {isDisable ? (
                          false
                        ) : (
                          <input
                            type="file"
                            name="serviceLogo"
                            className="form-control"
                            onChange={(e) => Handlefile(e, "serviceLogo")}
                          />
                        )}
                      </div> */}
                <div className="accordion-body">
                  <div className="row">
                    <div className={isFromOnboarding == 1 ? 'col-12' : "col-xxl-6 col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12"} >
                      <div className="mb-3">
                        <label className="form-label">
                          Service type <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                          classNamePrefix="react-select"
                          options={serviceOption}
                          placeholder="Choose"
                          name="RoleID"
                          value={serviceOption?.find(
                            (el) => el.value == formValue.serviceType
                          )}
                          onChange={(e) => handleSelectChange(e, "serviceType")}
                          isDisabled={isDisable}
                        />
                        <p className="text-color-70">
                          {" "}
                          Used to help clients find your service on BookYarra marketplace
                        </p>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className={isFromOnboarding == 1 ? 'col-12' : "col-xxl-6 col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12"}>
                        <div className="mb-0">
                          <div className="d-flex justify-content-between">
                            <label className="form-label">
                              Service {" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Link
                              // data-bs-toggle="modal"
                              // data-bs-target="#createCategoryModal"
                              className="form-label"
                              onClick={() => {
                                setIsopen(true);
                              }}
                            >
                              Create Category
                            </Link>
                          </div>
                        </div>

                        <Select
                          classNamePrefix="react-select"
                          options={Categorylist}
                          placeholder="Choose"
                          name="RoleID"
                          value={Categorylist?.find(
                            (el) => el.value == formValue.menuCategoryID
                          )}
                          onChange={(e) =>
                            handleSelectChange(e, "menuCategoryID")
                          }
                          isDisabled={isDisable}
                        />
                        <p className="text-color-70">
                          {" "}
                          The category is displayed to you and to clients online
                        </p>
                      </div>
                    </div>
                  </div>


                  <div className="row">
                    <div className={isFromOnboarding == 1 ? 'col-11' : "col-md-8"}>
                      <div className="mb-3">
                        <label className="form-label">
                          Service name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="serviceName"
                          value={formValue.serviceName}
                          onChange={handleChange}
                          disabled={isDisable}
                        />
                      </div>
                    </div>
                  </div>


                  {/* <div className="row">
                    <div className="container my-3">
                      <div className="card custome-card-padding rounded-2 mb-0">
                        <div className="row align-items-center">
                          <div className="col-auto">
                            <input
                              type="file"
                              name="serviceLogo"
                              className="d-none"
                              ref={(input) => (window.serviceLogoInput = input)}
                              onChange={(e) => Handlefile(e, "serviceLogo")}
                            />
                            <img
                              src={
                                formValue?.serviceLogoPreview
                                  ? formValue.serviceLogoPreview
                                  : formValue?.serviceLogo
                                    ? config.Imageurl + formValue.serviceLogo
                                    : NoImage
                              }
                              alt="Service Logo"
                              className="custome-image rounded-circle"
                              width="80"
                              height="80"
                              style={{
                                objectFit: "cover",
                                cursor: isDisable ? "default" : "pointer",
                              }}
                              onClick={() => {
                                if (!isDisable && window.serviceLogoInput) {
                                  window.serviceLogoInput.click();
                                }
                              }}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                              }}
                            />
                          </div>

                          <div className="col-auto">
                            <h6 className="mb-0 fw-bold">
                              Upload Service Image
                            </h6>
                            <small className="text-color-70">
                              Image should be below 500 kb
                            </small>
                          </div>

                          {!isDisable && (
                            <div className="col-auto d-flex gap-3 ms-auto">
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}


                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label className="form-label">
                          Service Description (Optional)
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          name="serviceDescription"
                          value={formValue.serviceDescription}
                          onChange={handleChange}
                          disabled={isDisable}
                        />
                      </div>
                    </div>
                  </div>
                  {isProvideHomeService == 1 && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="d-flex align-items-center mb-3">
                          <input
                            checked={formValue.isThisHomeService == 1}
                            type="checkbox"
                            className="form-check-input m-2 p-1"
                            name="isThisHomeService"
                            onChange={(e) => handleChangeCheckBox(e)}
                            disabled={isDisable}
                          />
                          <label className="form-label" style={{ marginTop: "8px" }}>
                            Is Home Service
                          </label>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-8">
                      <div className="d-flex align-items-center mb-3">
                        <input
                          checked={formValue.isThisComboService == 1}
                          type="checkbox"
                          className="form-check-input m-2 p-1"
                          name="isThisComboService"
                          onChange={(e) => handleChangeCheckBox(e)}
                          disabled={isDisable}
                        />
                        <label className="form-label" style={{ marginTop: "8px" }}>
                          Is Combo Service
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTwo"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTwo"
                >
                  <div className="card-title-head">
                    <h6 className="m-0 p-0" style={{ border: "none" }}>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Pricing and duration
                    </h6>
                  </div>
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTwo"
              >
                {formValue?.isThisComboService == 1 ? (
                  <div className="accordion-body row">
                    <div className="row col-md-6">
                      <div>
                        <label className="form-label">Search Services</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Services"
                          value={searchService}
                          onChange={(e) => setSearchService(e.target.value)}
                        />
                        {filterServiceData.length > 0 && (
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Suggested Services
                                </label>
                                <ul className="list-group custom-scroll-services">
                                  {filterServiceData.map((service) => (
                                    <li
                                      key={service.serviceId}
                                      className="list-group-item d-flex align-items-center"
                                      onClick={() => {
                                        handelSelectServiceForCombo(service);
                                        console.log(
                                          "Selected Service:",
                                          service
                                        );
                                        // Pass activity or handle selection logic here
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={
                                          service.imageUrl
                                            ? config.Imageurl + service.imageUrl
                                            : NoImage
                                        }
                                        alt={service.name}
                                        className="rounded-circle me-3"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                      <div>
                                        <h6 className="mb-0">{service.name}</h6>
                                        <small className="text-muted">
                                          {service.category} -{" "}
                                          {service.duration} -{" "}
                                          {service.priceType === "free"
                                            ? "Free"
                                            : `$${service.price}`}
                                        </small>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <label className="form-label">
                              Selected Services
                            </label>
                            <ul className="list-group">
                              {formValue.comboServiceIds &&
                                formValue.comboServiceIds
                                  .split(",")
                                  .map((id) => {
                                    const selectedService = serviceList.find(
                                      (service) =>
                                        service.serviceId.toString() === id
                                    );
                                    return (
                                      selectedService && (
                                        <li
                                          key={selectedService.serviceId}
                                          className="list-group-item d-flex align-items-center justify-content-between"
                                        >
                                          <div className="d-flex align-items-center">
                                            <img
                                              src={
                                                selectedService.imageUrl
                                                  ? config.Imageurl +
                                                  selectedService.imageUrl
                                                  : NoImage
                                              }
                                              alt={selectedService.name}
                                              className="rounded-circle me-3"
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                              }}
                                            />
                                            <div>
                                              <h6 className="mb-0">
                                                {selectedService.name}
                                              </h6>
                                              <small className="text-muted">
                                                {selectedService.category} -{" "}
                                                {selectedService.duration} -{" "}
                                                {selectedService.priceType ===
                                                  "free"
                                                  ? "Free"
                                                  : `$${selectedService.price}`}
                                              </small>
                                            </div>
                                          </div>
                                          <button
                                            className="btn text-danger btn-sm"
                                            onClick={() =>
                                              handelRemoveServicesForCombo(
                                                selectedService.serviceId
                                              )
                                            }
                                          >
                                            <Trash2 />
                                          </button>
                                        </li>
                                      )
                                    );
                                  })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Min Duration</label>
                          <Select
                            classNamePrefix="react-select"
                            options={dropdownOptions}
                            placeholder="Choose"
                            value={dropdownOptions?.find(
                              (els) =>
                                els.value ==
                                formValue.Pricingandduration[0].minDuration
                            )}
                            onChange={(e) =>
                              handleselectchange(0, e.value, "minDuration")
                            }
                            isDisabled={isDisable}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Max Duration</label>
                          <Select
                            classNamePrefix="react-select"
                            options={dropdownOptions}
                            placeholder="Choose"
                            value={dropdownOptions?.find(
                              (els) =>
                                els.value ==
                                formValue.Pricingandduration[0].maxDuration
                            )}
                            onChange={(e) =>
                              handleselectchange(0, e.value, "maxDuration")
                            }
                            isDisabled={isDisable}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Price type</label>
                          <Select
                            classNamePrefix="react-select"
                            options={priceType}
                            placeholder="Choose"
                            value={priceType?.find(
                              (els) =>
                                els.value ==
                                formValue.Pricingandduration[0].Pricetype
                            )}
                            onChange={(e) =>
                              handleselectchange(0, e.value, "Pricetype")
                            }
                            isDisabled={isDisable}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Price</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formValue.Pricingandduration[0].Price || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              console.log(value, "7777");
                              handlePriceChange(0, value);
                            }}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="accordion-body">
                    {formValue.Pricingandduration?.map((el, index) => (
                      <div className="row" key={index}>
                        <div className="col-lg-2 col-md-6">
                          <div className="mb-3">
                            <label className="form-label"> Min Duration</label>
                            <Select
                              classNamePrefix="react-select"
                              options={dropdownOptions}
                              placeholder="Choose"
                              value={dropdownOptions?.find(
                                (els) => els.value == el.minDuration
                              )}
                              onChange={(e) =>
                                handleselectchange(index, e.value, "minDuration")
                              }
                              isDisabled={isDisable}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="mb-3">
                            <label className="form-label"> Max Duration</label>
                            <Select
                              classNamePrefix="react-select"
                              options={dropdownOptions}
                              placeholder="Choose"
                              value={dropdownOptions?.find(
                                (els) => els.value == el.maxDuration
                              )}
                              onChange={(e) =>
                                handleselectchange(index, e.value, "maxDuration")
                              }
                              isDisabled={isDisable}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Price type</label>
                            <Select
                              classNamePrefix="react-select"
                              options={priceType}
                              placeholder="Choose"
                              value={priceType?.find(
                                (els) => els.value == el.Pricetype
                              )}
                              onChange={(e) =>
                                handleselectchange(index, e.value, "Pricetype")
                              }
                              isDisabled={isDisable}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Price</label>
                            <input
                              type="number"
                              className="form-control"
                              value={el.Price || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                console.log(value, "7777");

                                handlePriceChange(index, value);
                              }}
                              disabled={isDisable}
                            />
                          </div>
                        </div>

                        {isDisable == false && (
                          <div className="col-lg-2 col-md-6 mt-4">
                            <button
                              className="9 btn btn-primary btn-md btn-wave me-2 "
                              onClick={() => handleDelete(index)}
                            >
                              <Trash2 />
                            </button>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* {isDisable == false && (
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={handleaddvarent}
                      >
                        {" "}
                        Add variant{" "}
                      </button>
                    )} */}
                  </div>
                )}
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseThree"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseThree"
                >
                  <div className="card-title-head">
                    <h6 className="m-0 p-0" style={{ border: "none" }}>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Team Members
                    </h6>
                  </div>
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingThree"
              >
                <div className="accordion-body">
                  <div className="content">
                    <div className="page-header">
                      <div className="add-item d-flex">
                        <div className="page-title">
                          <h4>Team members required</h4>
                          <h6>
                            Choose which team members will perform this service
                          </h6>
                        </div>
                      </div>

                      <ul className="table-top-head">
                        <li>
                          <OverlayTrigger
                            placement="top"
                            overlay={renderCollapseTooltip}
                          >
                            <Link
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              id="collapse-header"
                              className={data ? "active" : ""}
                              onClick={() => {
                                dispatch(setToogleHeader(!data));
                              }}
                            >
                              <ChevronUp />
                            </Link>
                          </OverlayTrigger>
                        </li>
                      </ul>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex align-items-center gap-3">
                          <input
                            className="custome-boder form-check-input mt-0"
                            checked={parentchecked}
                            onChange={handleParentCheckboxChange}
                            type="checkbox"
                            disabled={isDisable}
                          />
                          <h5 className="mb-0 pr-2">
                            All Team Members
                            <span className="border border-light rounded-circle ms-2 px-2 py-1 small">
                              {productlist?.Count}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        {productlist?.map((el, index) => (
                          <React.Fragment key={index}>
                            <div className="d-flex align-items-center gap-3 mb-3">
                              <input
                                className="custome-boder form-check-input mt-0"
                                checked={el.Ischecked}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    index,
                                    e.target.checked,
                                    "Ischecked"
                                  )
                                }
                                type="checkbox"
                                disabled={isDisable}
                              />
                              <h6 className="mb-0 pr-2">{el?.fullName}</h6>
                            </div>
                            {index < productlist.length - 1 && <hr />}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddService;
